module.exports = __webpack_public_path__ + "img/icon_market.277fed75.png";